import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!

  return (_openBlock(), _createBlock(_component_el_dropdown_menu, null, {
    default: _withCtx(() => [
      (_ctx.user.type === 'founder')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/account/startups"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { icon: "el-icon-office-building" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_skeleton, {
                    loading: !_ctx.business,
                    animated: ""
                  }, {
                    template: _withCtx(() => [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "h3",
                        style: {"width":"140px"}
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(_ctx.business.name)), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, { to: "/account/profile" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown_item, {
            divided: _ctx.user.type === 'founder',
            icon: "el-icon-user"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Account Profile ", -1)
            ]))]),
            _: 1
          }, 8, ["divided"])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/account/settings" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown_item, { icon: "el-icon-setting" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Account Settings ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, [
        _createVNode(_component_el_dropdown_item, {
          divided: "",
          icon: "el-icon-right"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Logout ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}